import { HIDE_REQUEST_NOTIFICATION } from '../reducers/notificationReducer'

export const hideRequestNotification = () => {
    return (dispatch) => {
        dispatch({ type: HIDE_REQUEST_NOTIFICATION })
    }
}